import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpXsrfTokenExtractor
} from '@angular/common/http';
import { forwardRef, Inject, Injectable, Injector, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiEnvironmentService } from '../services/api-environment.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    @Inject(forwardRef(() => Injector)) private injector: Injector,
    private tokenExtractor: HttpXsrfTokenExtractor,
    private apiService: ApiEnvironmentService
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.apiService.getAuthToken();
    let modifiedRequest = request;
    if (token !== null && !request.headers.has('Authorization') && request.url.indexOf('HDWLocatorApi') > -1) {
      modifiedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next.handle(modifiedRequest).pipe(
      tap(
        () => {},
        error => {
          if (error instanceof HttpErrorResponse && error.status === 500) {
            console.error(`Server error ::: ${error.message}`);
          }
        }
      )
    );
  }
}

export const APP_INTERCEPTORS_LIST: Array<Provider> = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true
  }
];
